import { callApi } from '../../libs'

const getAllEvents = () => {
    return new Promise(async (resolve, reject) => {
        const url = `${process.env.REACT_APP_API_COVID19}/api/map-routes/event`
        const method = 'get'
        try {
            let response = await callApi(method, url, null, null)
            resolve(response)
        } catch (error) {
            reject(error)
        }
    })
}

export default getAllEvents